define('lq/hubFactory',[
    'underscore',
    'signalr',
    'signalr.hubs'
], function (_, signalR) {
    return function createHub(config) {
        var callbacks = {};
        var connection = null;
        var legacy = false;
        var hasStarted = false;

        const ensureStarted = function (extraParams = {}) {
            if (hasStarted) { return Promise.resolve(connection); }

            var query = _.extend({}, config.queryParams, extraParams);

            if ($.connection?.[config.hubName]) {
                legacy = true;
                connection = $.connection[config.hubName];

                connection.client.publishMessage = function (eventName, payload) {
                    _.each(callbacks[eventName], function(callback) {
                        callback(payload);
                    });
                };

                $.connection.hub.qs = query;

                return $.connection.hub.start()
                    .then(() => { hasStarted = true; return connection; });
            }

            var queryString = _.map(query, function(value, key) {
                return `${key}=${encodeURIComponent(value)}`;
            }).join('&');

            connection = new signalR.HubConnectionBuilder()
                .withUrl(`${config.hubUrl}?${queryString}`)
                .withAutomaticReconnect()
                .build();

            return connection.start()
                .then(() => { hasStarted = true; return connection; });
        };

        const addLocalListener = function (eventName, callback) {
            if (!callbacks[eventName])
                callbacks[eventName] = [];
            callbacks[eventName].push(callback);
        };

        const removeLocalListener = function (eventName) {
            if (callbacks[eventName]) {
                delete callbacks[eventName];
                if (!legacy) { connection?.off(eventName); }
            }
        };

        const listen = function (eventName, callback, extraParams) {
            addLocalListener(eventName, callback);

            return ensureStarted(extraParams).then(conn => {
                if (!legacy) {
                    conn.off(eventName);
                    conn.on(eventName, payload => 
                        _.each(callbacks[eventName], function(callback) {
                            callback(payload);
                    }));
                }
            });
        };

        const stopListening = function (eventName) {
            removeLocalListener(eventName);
        };

        return {

            listen: listen,

            stopListening: stopListening,

            startListeningAndSubscribe: function (eventName, callback, extraParams) {
                return listen(eventName, callback, extraParams).then(() => {
                    const qp = _.extend({}, config.queryParams, extraParams);

                    if (legacy && connection.server?.subscribeGroup)
                        return connection.server.subscribeGroup(qp);

                    if (!legacy)
                        return connection.invoke('SubscribeGroup', qp);
                });
            },

            stopListeningAndUnsubscribe: function (eventName, params) {
                stopListening(eventName);

                const qp = _.extend({}, config.queryParams, params);
                
                if (legacy)
                    return connection?.server?.unsubscribeGroup(qp);

                return connection?.invoke('UnsubscribeGroup', qp);
            }

        };
    };
});
